import jwtDecode from 'jwt-decode';

export const isUserDelegating = (token: string | null | undefined) => {
  if (!token) {
    return false;
  }

  const decoded = jwtDecode(token) as { original_user: any };

  return !!decoded.original_user;
};

export const tokenUserName = (token: string | null | undefined) => {
  if (!token) {
    return null;
  }

  const decoded = jwtDecode(token) as { sub: string };

  return decoded.sub;
};
